import React, { useState } from 'react'
import { SidebarMenuSubButton, SidebarMenuSubItem } from '../ui/sidebar'
import { NavLink } from 'react-router-dom'

const ChildLabel = ({ item }) => {
    return (
        <NavLink
            to={item.url}
            className={({ isActive }) => {
                return isActive ? 'bg-primary-red rounded-md ' : ''
            }}
        >
            <SidebarMenuSubItem key={item.title}>
                <SidebarMenuSubButton
                    asChild
                    className="hover:bg-transparent active:bg-transparent text-white hover:text-white active:text-white text-[12px] h-auto my-1"
                >
                <span className='text-white'>{item.icon}{item.title}</span>
                </SidebarMenuSubButton>
            </SidebarMenuSubItem>
        </NavLink>
    )
}

export default ChildLabel
